import { VIMOND_IMAGE_SERVICE_BASE_URL } from "../../constants";
import { callCurationProxy } from "../backend/backendClient";

/**
 * Response from the image upload endpoint
 * @property id - ID of the image pack
 * @property imageFileId - ID of the image file
 * @property imageUrl - URL of the image
 */
export interface ImageUploadResponse {
    id: string;
    imageFileId: string;
    imageUrl: string;
}

/**
 * Upload image from URI to the image service
 * @param imageUri
 */
export const uploadImageFromUri = async (imageUri: string): Promise<ImageUploadResponse> => {
    if (!imageUri) {
        throw new Error("Image URI is required.");
    }

    const response = await callCurationProxy({
        base: "imageUpload",
        path: "/image-uri",
        method: "PUT",
        body: {
            location: "main",
            uri: imageUri,
        },
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Image upload failed: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    const imageFileId = data?.mainImageLocation?.imageFileId;
    const imagePackId = data?.id;

    if (!imageFileId || !imagePackId) {
        throw new Error("Invalid response: missing imageFileId or imagePackId");
    }

    return {
        id: imagePackId,
        imageFileId: imageFileId,
        imageUrl: `${VIMOND_IMAGE_SERVICE_BASE_URL}/api/v2/img/${encodeURIComponent(imagePackId)}`,
    };
};
